// extracted by mini-css-extract-plugin
export default {"container":"ReadOnlyChoiceContainer_container__oWksF"};